// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1___d032efadb35c986e48c","cls2":"ImpactHubProfileCard-cls2__baf4090e997249d1f2a0 ImpactHubProfileCard-cls1___d032efadb35c986e48c"};